export default class BrixProductArchive {
  static init(...parameters) {
    return new BrixProductArchive(...parameters);
  }

  constructor(selector) {
    this.selector = selector;
    this.mobileView = false;

    const mobileView = () => {
      this.tabmenu = selector.querySelector('.tab-menu');
      this.openButton = selector.querySelector('.open-close-dropdown');

      const updateMobileMenuButton = () => {
        this.text = selector.querySelectorAll('.-active');
        let newValue;
        [...this.text].forEach((item) => {
          if (item.classList.contains('menu-item')) {
            newValue = item.innerText.trim();
          }
        });
        this.text = selector.querySelector('.menu-text');
        if (newValue) {
          this.text.innerText = newValue;
        } else {
          this.text.innerText = 'menu';
        }
        this.tabmenu.classList.add('-closed');
        this.tabmenu.classList.remove('-open');
        this.openButton.classList.add('-up');
        this.openButton.classList.remove('-down');
      };

      updateMobileMenuButton();

      const openMobileMenu = () => {
        if (this.openButton.classList.contains('-up')) {
          this.tabmenu.classList.add('-open');
          this.tabmenu.classList.remove('-closed');
          this.openButton.classList.add('-down');
          this.openButton.classList.remove('-up');
        } else {
          this.tabmenu.classList.add('-closed');
          this.tabmenu.classList.remove('-open');
          this.openButton.classList.add('-up');
          this.openButton.classList.remove('-down');
        }
      };
      this.openButton.addEventListener('click', () => openMobileMenu());
      this.tabmenu.addEventListener('click', event => updateMobileMenuButton(event));
    };

    if (window.innerWidth < 768) {
      //  First render if page is mobile to get top menu name
      if (!this.mobileView) {
        this.mobileView = true;
        mobileView();
      }
    }

    window.addEventListener('resize', () => {
      // Render on resize to check if window innerheight is below 768px a.k.a mobile view
      if (window.innerWidth < 768) {
        if (!this.mobileView) {
          this.mobileView = true;
          mobileView();
        }
      }
    });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-product-archive', BrixProductArchive.init);
}
